var _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _text5, _text6, _text7, _rect4, _text8, _rect5, _text9, _rect6, _rect7, _rect8, _text0, _text1, _text10, _rect9, _rect0, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraJqlDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 36,
    fill: "#F7FAFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 1116,
    height: 636,
    rx: 28,
    fill: "white",
    stroke: "#DDE6EF",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 108,
    fill: "#13213F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 40,
    fontWeight: 700
  }, "JQL Queries and Dashboard Thinking")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 146,
    fill: "#58657A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24
  }, "Filters for action, gadgets for visibility, reports for release confidence")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 204,
    width: 470,
    height: 360,
    rx: 28,
    fill: "#13213F"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 258,
    fill: "#9DD1FF",
    fontFamily: "Courier New, monospace",
    fontSize: 25
  }, "project = QA")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 302,
    fill: "#FFFFFF",
    fontFamily: "Courier New, monospace",
    fontSize: 25
  }, "AND issuetype = Bug")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 346,
    fill: "#FFFFFF",
    fontFamily: "Courier New, monospace",
    fontSize: 25
  }, "AND status in (\"Open\",\"Retest\")")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 390,
    fill: "#FFFFFF",
    fontFamily: "Courier New, monospace",
    fontSize: 25
  }, "AND priority in (High, Critical)")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 434,
    fill: "#FFFFFF",
    fontFamily: "Courier New, monospace",
    fontSize: 25
  }, "ORDER BY created DESC")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 474,
    width: 158,
    height: 46,
    rx: 14,
    fill: "#2658D9"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 505,
    fill: "white",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Save Filter")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 204,
    width: 526,
    height: 164,
    rx: 24,
    fill: "#F8FBFF",
    stroke: "#D6E5FF",
    strokeWidth: 3
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 628,
    y: 248,
    fill: "#173E9F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "Dashboard Gadgets")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 278,
    width: 136,
    height: 58,
    rx: 16,
    fill: "#EAF2FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 278,
    width: 136,
    height: 58,
    rx: 16,
    fill: "#FFF2E8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 944,
    y: 278,
    width: 136,
    height: 58,
    rx: 16,
    fill: "#EEF9F1"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 654,
    y: 314,
    fill: "#173E9F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Pie Chart")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 814,
    y: 314,
    fill: "#B86414",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Burndown")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 314,
    fill: "#1D7A4D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Stats")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 398,
    width: 250,
    height: 166,
    rx: 24,
    fill: "#FFF8EA",
    stroke: "#FFE3B9",
    strokeWidth: 3
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 398,
    width: 250,
    height: 166,
    rx: 24,
    fill: "#F4FCF7",
    stroke: "#D8F0E0",
    strokeWidth: 3
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 440,
    fill: "#B86414",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "What QA tracks")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 478,
    fill: "#4B5565",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21
  }, "Open blockers")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 510,
    fill: "#4B5565",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21
  }, "Reopened defects")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 542,
    fill: "#4B5565",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21
  }, "Sprint leakage")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 894,
    y: 440,
    fill: "#1D7A4D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "What leaders track")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 894,
    y: 478,
    fill: "#4B5565",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21
  }, "Release risk")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 894,
    y: 510,
    fill: "#4B5565",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21
  }, "Defect trends")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 894,
    y: 542,
    fill: "#4B5565",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21
  }, "Velocity impact")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraJqlDashboard);
export default __webpack_public_path__ + "static/media/jira-jql-dashboard.a561c58ff3d03e8027535fc5a5e8d74b.svg";
export { ForwardRef as ReactComponent };